import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { fetchFromApi, ApiResponse } from '../apiClient';
import { ProcessCategory } from 'types/processesTypes';
import { useUI } from 'contexts/UiContext';
import { findProcessTranslationKeyInsensitive } from '../../utils/processesUtils';

// Base API URL
const REACT_APP_DARWIN_URL = import.meta.env.VITE_DARWIN_URL;

// Query keys
export const PROCESSES_QUERY_KEY = 'processes';

/**
 * Fetch FDA processes.
 */
export const useGetFdaProcesses = () => {
  const { t } = useTranslation();
  const { selectedCompany } = useUI();

  return useQuery({
    queryKey: [PROCESSES_QUERY_KEY, selectedCompany],
    queryFn: () =>
      fetchFromApi<ProcessCategory[]>(
        `${REACT_APP_DARWIN_URL}/processes/${selectedCompany}`
      ),
    select: (response: ApiResponse<ProcessCategory[]>) => {
      const transformedData = response.data.map(category => ({
        ...category,
        processes: category.processes.map(process => ({
          ...process,
          name: (() => {
            const translationKey = findProcessTranslationKeyInsensitive(
              process.name
            );
            return translationKey ? t(translationKey) : process.name;
          })(),
        })),
      }));
      return { ...response, data: transformedData };
    },
  });
};
